import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Heading, Icon, Image } from "@chakra-ui/react";
import { TbChevronsRight } from "react-icons/tb";

// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");
  const brandColor = useColorModeValue("brand.800", "white");

  return (
    <Flex align='center' direction='column'>
      <Heading  p={'15px'} size="lg" style={{ fontStyle: 'italic', fontWeight: '900' }}>LOGOHOUSE</Heading>
    <HSeparator mb='20px' />
  </Flex>
  );
}

export default SidebarBrand;
